import { Logger, tagReplacers } from '../index'
export const stringifyOnClient = (args?: object | undefined) => {
    return global.__SERVER__ === true ? args : args && JSON.stringify(args)
}

const tagRegEx = /\$?\{([^\}]+)\}/g
export type IReplaceObj = { [key: string]: string }

export const fillValues = (str?: string, replace?: IReplaceObj, logger?: Logger) => {
    if (!str) {
      return ''
    }
  
    const tags = str.match(tagRegEx)
  
    // return original string if no tags to replace
    if (!(tags && tags.length > 0)) {
      return str
    }
  
    // replace tags
    return tags.reduce((result, tag) => {
      const tagName = tag.replace(/\$?\{([^}|]+)([^}]+)?\}/, '$1')
      if (replace && typeof replace[tagName] !== 'undefined') {
        return result.replace(tag, replace[tagName])
      } else {
        if (!tagReplacers.includes(tagName) && logger) {
          logger.error(
            `Missing replace value for ${tag} in "${str}"`
          )
        }
        return result
      }
    }, str)
  }

  export type DVStringAttrs = { [key: string]: { [key: string]: string } }
  export const buildDvString = (string: string, attrs: DVStringAttrs = {}) => ({
    string,
    attrs
  })